module.exports = __webpack_public_path__ + "img/Bodice-Front-B3-Gd-Da-Ed.acd892b3.png";